<template>
  <v-dialog :value="clientId" max-width="600px">
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="#2196F3"
    />

    <v-card class="modal-card" v-if="0 === countSingleCardTypes">
      <v-card-title class="pa-6">Разовое посещение</v-card-title>
      <v-card-text class="pa-6">
        <v-alert type="info" dense>
          К сожалению у вас нет разовых абонементов. Добавьте новый вид абонемента с разовым посещением
        </v-alert>
      </v-card-text>
      <v-card-actions class="px-6 py-5">
        <v-spacer></v-spacer>
        <v-btn depressed dark color="blue-grey" @click="close" min-width="120" class="mx-2">Закрыть</v-btn>
        <v-btn depressed color="primary" :to="{name: 'card-types.list'}" min-width="120">Добавить</v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="modal-card" v-else>
      <v-card-title class="pa-6">Разовое посещение</v-card-title>
      <v-card-text class="pa-6">
        <div class="message-group" style="margin-bottom: 0;">
          <div class="message-heading">
            <div class="message-heading__title">Вы уверены что хотите отметить разовое посещение?</div>
          </div>
        </div>
        <v-row v-if="countSingleCardTypes > 1">
          <v-col cols="12" class="pb-0">
            <v-select
              v-model="singleCardTypeId"
              :items="singleCardTypes"
              item-text="name"
              item-value="id"
              outlined
              label="Вид абонемента"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-6 py-5">
        <v-spacer></v-spacer>
        <v-btn depressed dark color="blue-grey" @click="close" min-width="120" class="mx-2">Закрыть</v-btn>
        <v-btn depressed color="success" @click="trackVisit" min-width="120">
          <v-icon left>mdi-check</v-icon>
          Отметить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex';
  import visitApi from '../api/visit.api';

  export default {
    name    : 'SingleVisitDialog',
    model   : {
      prop: 'clientId',
    },
    props   : {
      clientId: {
        required: true,
      }
    },
    data() {
      return {
        // dialog    : this.clientId,
        cardTypeId: null,
      };
    },
    computed: {
      ...mapState({
        cardTypes      : state => state['card-types'].items,
        cardTypesStatus: state => state['card-types'].status,
      }),
      singleCardTypes() {
        return this.cardTypes.filter(cardType => cardType.visits_limit === 1);
      },
      countSingleCardTypes() {
        // return 1;
        return this.singleCardTypes.length;
      },
      loading() {
        return this.$constants.RESOURCE_STATUS_LOADED !== this.cardTypesStatus;
      },
      singleCardTypeId: {
        get() {
          let value = null;

          if (this.cardTypeId) {
            value = this.cardTypeId;
          } else {
            value = this.countSingleCardTypes ? this.singleCardTypes[0].id : null;
          }

          return value;
        },
        set(value) {
          this.cardTypeId = value;
        }
      }
    },
    methods : {
      close() {
        // this.dialog = false;
        this.$emit('input', null);
      },
      trackVisit() {
        this.$store.commit('setLoading', true);

        visitApi.singleVisit({ 'card_type_id': this.singleCardTypeId, 'client_id': this.clientId }).then(() => {
          this.$toast.success('Разовое посещение отмечено');
          this.$emit('marked');
          this.close();
        }).catch(() => {
          this.$toast.error('Что-то пошло не так. Пожалуйста, повторите попытку позже');
        }).finally(() => {
          this.$store.commit('setLoading', false);
        });
      }
    }
  };
</script>

<style scoped>

</style>
